/**
 * @class CanvasWM canvas生成水印类
 * @param {Object} container 承载水印的父组件
 * @param {String} content 水印文本内容
 * @param {Object} props 参数
 * @param {String} zIndex 水印蒙层深度 4是设计弹窗的深度 1000是辅助表管理弹窗的深度，2000以上是element-ui弹窗的深度，水印要比除设计弹窗外的深度低，比其他要高
 * */
class CanvasWM {
  static instance
  width = '300px'
  height = '200px'
  props
  content
  container
  zIndex
  constructor (props) {
    this.props = props
    this.container = props.container
    this.content = props.content
    this.zIndex = props.zIndex
  }

  createWM () {
    let canvas = document.createElement('canvas')
    canvas.setAttribute('width', '240px')
    canvas.setAttribute('height', '130px')
    let ctx = canvas.getContext('2d')
    ctx.fillStyle = 'rgba(222, 222, 222, 0.6)'
    ctx.textAlign = 'left'
    ctx.textBaseline = 'middle'
    ctx.font = '300 12px SimHei'
    ctx.rotate(Math.PI / 180 * -15)
    ctx.fillText(this.content, 10, 100)
    let base64Url = canvas.toDataURL()
    let __WM = document.querySelector('.__WM')
    const waterMarkDiv = __WM || document.createElement('div')
    const wmStyle = `
        position: absolute;
        z-index: ${this.zIndex};
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
        background-repeat: repeat;
        background-image: url('${base64Url}');
    `
    waterMarkDiv.setAttribute('style', wmStyle)
    waterMarkDiv.classList.add('__WM')
    if (!__WM) {
      this.container.insertBefore(waterMarkDiv, this.container.firstChild)
    }
    if (MutationObserver) {
      let _this = this
      let mo = new MutationObserver(function () {
        const wm = document.querySelector('.__WM')
        if ((wm && wm.getAttribute('style') !== wmStyle) || !wm) {
          mo.disconnect()
          mo = null
          _this.createWM()
        }
      })
      mo.observe(this.container, {
        attributes: true,
        subtree: true,
        childList: true
      })
    }
  }
}

export default CanvasWM



// WEBPACK FOOTER //
// ./src/components/public/waterMark/CanvasWM.js